import {
  ImageDownloadBatchArg,
  ImageDownloadBatchParams,
  ImageFormatInfoParams,
  ImageFormatParams,
  ImageQualityInfoParams,
  ImageQualityParams,
  ZipStartParams
} from '@aipb/dropbox/model';
import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { DropboxWrapperApiService } from '../api';
import { DropboxRepository } from './dropbox.repository';

@Injectable({
  providedIn: 'root'
})
export class DropboxService {
  private repository = inject(DropboxRepository);
  private api = inject(DropboxWrapperApiService);

  imageDownload(path: string) {
    return this.api.imageDownload(path);
  }

  imageDownloadBatch(
    images: ImageDownloadBatchArg[],
    params: ImageDownloadBatchParams = {
      size: 'w640h480',
      mode: 'strict'
    }
  ) {
    return this.api.imageDownloadBatch(images, params).pipe(
      tap((data) => {
        data.forEach((data) => {
          this.repository.setImage(data.id, data.thumbnail);
        });
      })
    );
  }

  imageQuality(params: ImageQualityParams) {
    return this.api.imageQuality(params);
  }

  imageQualityInfo(params: ImageQualityInfoParams) {
    return this.api.imageQualityInfo(params);
  }

  imageFormatInfo(params: ImageFormatInfoParams) {
    return this.api.imageFormatInfo(params);
  }

  imageFormat(params: ImageFormatParams) {
    return this.api.imageFormat(params);
  }

  zipInit() {
    return this.api.zipInit();
  }

  zipStart(params: ZipStartParams) {
    return this.api.zipStart(params);
  }

  zipProgress(id: string) {
    return this.api.zipProgress(id);
  }

  zipDownload(id: string) {
    return this.api.zipDownload(id);
  }
}
